import { apiAxios } from '@/lib/apiAxios';
export const fetchCurrentUser = () => apiAxios.get('/users/me').then((response) => response.data);
export const updateUser = ({ data }) => apiAxios.put('/users/me', data).then((response) => response.data);
export const deleteUser = () => apiAxios.delete('/users/me').then((response) => response.data);
export const patchLocale = ({ locale }) => apiAxios.patch('/users/me/locale', { locale }).then((response) => response.data);
export const patchTheme = ({ theme }) => apiAxios.patch('/users/me/theme', { theme }).then((response) => response.data);
export const patchPalette = ({ palette }) => apiAxios.patch('/users/me/palette', { palette }).then((response) => response.data);
export const patchAnimation = ({ animation }) => apiAxios
    .patch('/users/me/animation', { animation })
    .then((response) => response.data);
export const uploadImage = async ({ imageFile }) => {
    const formData = new FormData();
    formData.append('imageFile', imageFile);
    const response = await apiAxios.post('/users/me/uploads', formData);
    return response.data;
};
export const changePassword = (data) => apiAxios.put('/users/me/change-password', data).then((response) => response.data);
export const fetchCurrentWorkspace = () => apiAxios.get('/users/me/current-workspace').then((response) => response.data);
export const fetchWorkspaces = () => apiAxios.get('/users/me/workspaces').then((response) => response.data);
export const switchWorkspace = (workspacePublicId) => apiAxios
    .patch(`/users/me/workspaces/${workspacePublicId}`)
    .then((response) => response.data);
export const disconnectOAuth = (provider) => apiAxios.delete(`/oauth/connect/${provider}`).then((response) => response.data);
